import {EditOutlined} from '@ant-design/icons';
import {IconButton} from '@ds/components';
import {cn} from '@ds/helpers';

type CpcInfoRowProps = {
  title: React.ReactNode;
  value: React.ReactNode;
  onEdit?: () => void;
  hasBorder?: boolean;
};

const CpcInfoRow: React.FC<CpcInfoRowProps> = ({title, value, onEdit, hasBorder = true}) => {
  return (
    <div
      className={cn(
        'flex min-h-15 items-center justify-between gap-3 px-4 py-2',
        hasBorder && 'border-b border-gray-03'
      )}
    >
      <div className="flex min-w-0 flex-1 items-center justify-between gap-1 text-body-sm">
        <span className="text-gray-07">{title}</span>
        <span className="text-neutral-fg">{value}</span>
      </div>
      {onEdit ? (
        <IconButton aria-label={`ویرایش ${String(title)}`} size="md" onClick={onEdit}>
          <EditOutlined aria-hidden />
        </IconButton>
      ) : null}
    </div>
  );
};

export default CpcInfoRow;
